import { referencesConstants } from "../constants";


const start = () => {
    return {type: referencesConstants.START, payload: {loading: true}};
};

const stop = () => {
    return {type: referencesConstants.STOP, payload: {loading: false}};
};

const list = (res) => {
    return {type: referencesConstants.LIST, payload: {list: res}};
};

const add = (res) => {
    return {type: referencesConstants.ADD, payload: {add: res}};
};

const update = (res) => {
    return {type: referencesConstants.UPDATE, payload: {update: res}};
};

const remove = (res) => {
    return {type: referencesConstants.REMOVE, payload: {remove: res}};
};

const clear = () => {
    return {type: referencesConstants.CLEAR, payload: {list: []}};
};

export const referencesSelectors = {
    start,
    stop,
    list,
    add,
    update,
    remove,
    clear
}